const testIds = {
    partialLoginContainer: 'e2e.signupAndLogin.partial-login',
    loginAPIError: 'e2e.signupAndLogin.apiError',
    registerFormToggleButton: 'e2e.signupAndLogin.registerForm.toggleButton',
    loginFormToggleButton: 'e2e.signupAndLogin.loginForm.toggleButton',
};

export default testIds;
